export const HTTPS = 'https://';
